import { validator } from "LIB/validate-this";
import { get } from "lodash";
import * as rules from "LIB/validation/rules";
import { validateLineItem } from "MODULES/IncomingQuotes/Parts/validate";
import {
  COMPANY,
  COMPANY_ID,
  CONTACT_ID,
  EMAIL,
  NAME
} from "APP_ROOT/constants";
import { CONTACT } from "MODULES/companies/constants";
import { BUYER_ID } from "MODULES/users/constants";

export default function validate(values) {
  return validator(values, form => {
    if (
      (!values.contact_id && !get(values, "company.website")) ||
      (values.contact && [NAME, EMAIL].some(f => values.contact[f]))
    ) {
      form.validateChild(CONTACT, contactForm => {
        contactForm.validate(NAME, EMAIL).satisfies(rules.required);
        contactForm.validate(EMAIL).satisfies(rules.isValidEmail);
      });
    } else if (values.company_id) {
      form.validate(CONTACT_ID).satisfies(rules.required);
    }

    if (values.company_id) {
      form.validate(COMPANY_ID).satisfies(rules.required);
    } else {
      form.validateChild(COMPANY, company => {
        company.validate(NAME).satisfies(rules.required);
      });
    }

    form.validate(BUYER_ID).satisfies(rules.required);
    form.validateChild("incoming_quote_line_item", lineItem => {
      validateLineItem(lineItem, values, "incoming_quote_line_item");
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/IncomingQuotes/Create/validate.js